export default __webpack_public_path__ + "static/media/19.222ff1b0.jpg";